export const filterSection = (section, sectionName, data) =>
  data[section].filter(section => section.name === sectionName)[0];
